import React from 'react';
import Config from './modules/config';
import Message from './message';
import T from './modules/translation';

class SgfPanel extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showOpenFilePanel: false,
      message: ""
    }
    this.sgfRef = React.createRef();
    this.fileInput = React.createRef();
    this.encodingRef = React.createRef();
    this.copyToClipboard = this.copyToClipboard.bind(this);
    this.pasteFromClipboard = this.pasteFromClipboard.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.share = this.share.bind(this);
    this.toggleOpenFilePanel = this.toggleOpenFilePanel.bind(this);
  }

  copyToClipboard(e) {
    e.preventDefault();
    if (!navigator.clipboard) {
      alert(T.get("clipBoardNotSupported"));
      return;
    }
    this.setState({ message: T.get("copiedToClipBoard") });
    navigator.clipboard.writeText(this.props.sgf)
      .then(function () {
        console.log(T.get("copiedToClipBoard"));
      }, function () {
        alert(T.get("clipBoardNotSupported"));
      })
      .catch(reason => { alert(reason); }
      );
  }

  async pasteFromClipboard(e) {
    e.preventDefault();
    if (!navigator.clipboard) {
      alert(T.get("clipBoardNotSupported"));
      return;
    }
    try {
      const clipText = await navigator.clipboard.readText();
      this.paste(clipText);
    } catch (reason) {
      alert(reason);
    }
  }

  handleSubmit(event) {
    event.preventDefault();
    const file = this.fileInput.current.files[0];
    const reader = new FileReader();
    reader.onload = () => this.paste(reader.result);
    const encoding = this.encodingRef.current.selectedOptions[0].value;
    console.log(`Open ${file.name} (${encoding})`);
    reader.readAsText(file, encoding);
    Config.getInstance().set("encoding", encoding);
    this.setState({ showOpenFilePanel: false });
  }

  paste(text) {
    this.sgfRef.current.value = text;
    this.props.onPaste(text);
  }

  share(e) {
    e.preventDefault();
    if (!navigator.clipboard) {
      alert(T.get("clipBoardNotSupported"));
      return;
    }
    this.setState({ message: T.get("copiedLinkToClipBoard") });
    const loc = window.location;
    const url = loc.protocol + "//" + loc.host + loc.pathname
      + "?sgf=" + encodeURI(this.props.sgf)
      + "&num=" + this.props.moveNumber;
    navigator.clipboard.writeText(url)
      .then(function () {
        console.log(T.get("copiedLinkToClipBoard"), url);
      }, function () {
        alert(T.get("clipBoardNotSupported"));
      })
      .catch(reason => { alert(reason); }
      );
  }

  toggleOpenFilePanel(e) {
    e.preventDefault();
    this.setState((state) => ({
      showOpenFilePanel: !state.showOpenFilePanel
    }));
  }

  getOpenFilePanel() {
    if (!this.state.showOpenFilePanel) {
      return null;
    }
    return (
      <div className="card open-file-panel mt-0">
        <div className="card-body">
          <form onSubmit={this.handleSubmit}>
            <div className="mb-2 mt-2">
              <input className="form-control" type="file" id="inputFile" ref={this.fileInput} />
            </div>
            <div className="row mb-3">
              <div className="col-4">
                <label htmlFor="encodings" className="form-label">{T.get("encoding")}</label>
              </div>
              <div className="col-8">
                <select className="form-select encodings" id="encodings"
                defaultValue={Config.getInstance().get("encoding", "UTF-8")}
                ref={this.encodingRef}>
                  <option>UTF-8</option>
                  <option>Shift_JIS</option>
                  <option>GB2312</option>
                  <option>EUC-KR</option>
                </select>
              </div>
            </div>
            <div className="d-grid">
              <input type="submit" className="btn btn-warning btn-lg" />
            </div>
          </form>
        </div>
      </div>
    );
  }

  getSgfSource() {
    if (this.state.showOpenFilePanel) {
      return null;
    }
    return <textarea className="form-control sgf-source" rows="3" readOnly
      ref={this.sgfRef}
      value={this.props.sgf} />
  }

  render() {
    const downloadUrl = "https://fujigoban.appspot.com/kifu/download?sgf=" + encodeURI(this.props.sgf);

    return (
      <div>
        <div className="card sgf-panel">
          <div className="card-body">
            {this.getSgfSource()}
            {this.getOpenFilePanel()}
            <div className="container-fluid gx-3">
              <button className="btn btn-primary sgf-new mt-2 me-2" type="submit"
                onClick={event => window.location.href = './'}>
                <span className="bi bi-plus" aria-hidden="true"></span>
                {T.get("new")}
              </button>
              <button className="btn btn-primary open-file mt-2 me-2" type="submit"
                onClick={this.toggleOpenFilePanel}>
                <span className="bi bi-folder2-open" aria-hidden="true"></span>
                {T.get("open")}
              </button>
              <a className="btn btn-primary save-file mt-2 me-2"
                href={downloadUrl} role="button" target="fujigoban">
                <span className="bi bi-download" aria-hidden="true"></span>
                {T.get("save")}
              </a>
              <button className="btn btn-primary sgf-copy mt-2 me-2" type="submit"
                onClick={this.copyToClipboard}>
                <span className="bi bi-clipboard-plus" aria-hidden="true"></span>
                {T.get("copy")}
              </button>
              <button className="btn btn-primary sgf-paste mt-2 me-2" type="submit"
                onClick={this.pasteFromClipboard}>
                <span className="bi bi-clipboard" aria-hidden="true"></span>
                {T.get("paste")}
              </button>
              <button className="btn btn-primary sgf-restore mt-2 me-2" type="submit"
                onClick={this.props.onRestore}>
                <span className="bi bi-arrow-counterclockwise" aria-hidden="true"></span>
                {T.get("restore")}
              </button>
              <button className="btn btn-primary sgf-share mt-2 me-2" type="submit"
                onClick={this.share}>
                <span className="bi bi-share" aria-hidden="true"></span>
                {T.get("share")}
              </button>
            </div>
            <Message text={this.state.message} />
          </div>
        </div>
      </div>
    );
  }
}

export default SgfPanel;